import React from 'react';
import {Linking, Platform, TouchableOpacity} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {
  AccountMenus,
  AccountMenuItem,
  AccountMenuIcon,
  AccountIconBox,
  AccountMenuTitle,
} from './styles';
import {useAuth} from '../../../../context/auth';
import { useGlobal } from '../../../../context/global';

type MenuItem = {
  label: string;
  icon: string;
  requiresLogin: boolean;
  screen?: string;
  url?: string;
  action?: 'avalieGanhe';
};

const AJUDA_FALLBACK: MenuItem = {
  label: 'Quero Ajuda',
  icon: 'circle-question',
  screen: 'Help',
  requiresLogin: false,
};

const MEUS_CARTOES_FALLBACK: MenuItem = {
  label: 'Meus\nCartões',
  icon: 'credit-card',
  screen: 'CardsWallet',
  requiresLogin: true,
};

const MINHAS_COMPRAS_FALLBACK: MenuItem = {
  label: 'Minhas\nCompras',
  icon: 'clock-rotate-left',
  screen: 'PaymentsHistory',
  requiresLogin: true,
};

const TERMOS_DE_USO_FALLBACK: MenuItem = {
  label: 'Termos\nde Uso',
  icon: 'file-lines',
  url: 'https://barataocombustiveis.com.br/termos-e-condicoes',
  requiresLogin: false,
};

const TUTORIAIS_FALLBACK: MenuItem = {
  label: 'Como Comprar?',
  icon: 'circle-play',
  screen: 'Tutoriais',
  requiresLogin: false,
};

interface AccountMenusGridProps {
  onAvalieGanhePress: () => void;
}

export function AccountMenusGrid({onAvalieGanhePress}: AccountMenusGridProps) {
  const navigation = useNavigation();
  const {isLogged, setShowSign} = useAuth();

    const {disabledFeatures} = useGlobal();
      const isDisabled = (key: string) => disabledFeatures.includes(key);


const items: MenuItem[] = [
  Platform.OS === 'android'
    ? isDisabled('avalie')
      ? AJUDA_FALLBACK
      : {
          label: 'Avalie &\nGanhe',
          icon: 'star-half-stroke',
          action: 'avalieGanhe' as const,
          requiresLogin: false,
        }
    : isDisabled('checkin')
      ? AJUDA_FALLBACK
      : {label: 'Check-in\nDiário', icon: 'calendar-check', screen: 'Checkin', requiresLogin: true},
  Platform.OS === 'android'
    ? isDisabled('beneficios')
      ? MEUS_CARTOES_FALLBACK
      : {label: 'Benefícios\nHoje', icon: 'gift', screen: 'Beneficios', requiresLogin: true}
    : isDisabled('roleta')
      ? MEUS_CARTOES_FALLBACK
      : {label: 'Gire &\nGanhe', icon: 'gift', screen: 'Roulette', requiresLogin: true},
  isDisabled('indique')
    ? MINHAS_COMPRAS_FALLBACK
    : {label: 'Indique &\nGanhe', icon: 'money-bill-wave', screen: 'ReferAndWin', requiresLogin: true},
  isDisabled('fipe')
    ? TERMOS_DE_USO_FALLBACK
    : {label: 'Consultar\nFIPE', icon: 'car', screen: 'Fipe', requiresLogin: true},
  isDisabled('reembolso')
    ? TUTORIAIS_FALLBACK
    : {label: 'Reembol-\nsos', icon: 'money-bill-transfer', screen: 'Reembolsos', requiresLogin: true},
];


  function handlePress(item: MenuItem) {
    if (item.requiresLogin && !isLogged) {
      return setShowSign(true);
    }
    if (item.action === 'avalieGanhe') {
      return onAvalieGanhePress();
    }
    if (item.url) {
      return Linking.openURL(item.url);
    }
    if (item.screen) {
      navigation.navigate(item.screen as never);
    }
  }

  return (
    <>
      <AccountMenus>
        {items.map(item => (
          <TouchableOpacity
            key={item.label}
            activeOpacity={0.7}
            style={{flex: 1, alignItems: 'center'}}
            onPress={() => handlePress(item)}>
            <AccountMenuItem>
              <AccountIconBox>
                <AccountMenuIcon name={item.icon} solid />
              </AccountIconBox>
              <AccountMenuTitle>{item.label}</AccountMenuTitle>
            </AccountMenuItem>
          </TouchableOpacity>
        ))}
      </AccountMenus>
    </>
  );
}
